import React, { useEffect, useState } from "react";
import { EaseModal } from "../../../libs/EaseModal";
import { Button, Checkbox, Form, Icon, Upload } from "antd";
import { InstaCollectSettingsModel } from "../../../models";
import { alertify, handleApiExceptions, size_greater_than } from "../../../app_methods";
import { connect } from "react-redux";
import { updateCurrentUserAction } from "../../../redux/actions";
import { Text1, Text4 } from "../../../styles";
import { PermissionHoc } from "../../HOC";
import { cloneDeep } from "lodash";

let QRLogoConfigModal = (props) => {
    const [isSaving, setIsSaving] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const { form, current_user, updateCurrentUser, toggleConfigQRLogoModal, visible } = props;
    const smart_collect_virtual_account_settings = current_user?.smart_collect_virtual_account_settings ?? {};

    const logo_remote_file_location = smart_collect_virtual_account_settings?.logo_remote_file_location;
    const { getFieldDecorator } = form;
    const file = form.getFieldValue("file") || null;
    const update_for_all_cva = form.getFieldValue("update_for_all_cva") || false;
    const update_for_all_submerchants = form.getFieldValue("update_for_all_submerchants") || false;
    const [imageUrl, setImageUrl] = useState(null);

    const handleFileChange = (info) => {
        if (info.file.status === "uploading") {
            setIsUploading(true);
            return;
        }
        getBase64(info.file, (imageUrl) => setImageUrl(imageUrl));
        setIsUploading(false);
    };

    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    const updateQRLogo = async (values) => {
        setIsSaving(true);
        try {
            const response = await InstaCollectSettingsModel.update_qr_logo(values);
            if (!response.success) {
                handleApiExceptions(response);
                setIsSaving(false);
            } else {
                if (values?.update_for_all_submerchants || values?.update_for_all_cva) {
                    alertify(
                        "Success",
                        `Logo updated successfully.
                        Updation of the logo on existing  ${
                            (values?.update_for_all_cva && `Virtual Accounts`) ||
                            (values?.update_for_all_submerchants && `Merchant Accounts`)
                        } shall be done in some time.`,
                        "success"
                    );
                } else alertify("Success", response?.data?.message || `Logo updated successfully.`, "success");
                toggleConfigQRLogoModal();
                const updatedVirtualAccountSettings = cloneDeep(smart_collect_virtual_account_settings);
                if (imageUrl) updatedVirtualAccountSettings.logo_remote_file_location = imageUrl;
                updateCurrentUser({
                    ...current_user,
                    smart_collect_virtual_account_settings: updatedVirtualAccountSettings,
                });
            }
        } catch (error) {
            handleApiExceptions({ success: false, data: "Something went wrong", status: 500 });
            setIsSaving(false);
        } finally {
            setIsSaving(false);
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            updateQRLogo(values);
        });
    };

    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Configure UPI QR Logo
            </Text1>
        );
    };
    return (
        <EaseModal
            width={400}
            title={false}
            visible={visible}
            onCancel={() => {
                form.resetFields();
                toggleConfigQRLogoModal();
                setImageUrl(null);
            }}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <Form onSubmit={onSubmit}>
                <Form.Item className="m-0">
                    {getFieldDecorator("file", {
                        valuePropName: "file",
                        rules: [
                            {
                                validator: (rule, value, callback) => {
                                    if (!value) {
                                        callback();
                                        return;
                                    }
                                    const file = value.file;
                                    size_greater_than(file, 15000) ? callback(true) : callback();
                                },
                                message: "File size cannot exceed 15 KB",
                            },
                        ],
                    })(
                        <Upload.Dragger
                            loading={isUploading}
                            name="file"
                            multiple={false}
                            showUploadList={false}
                            className="pl-0 d-block qr-logo-uploader"
                            beforeUpload={(file) => {
                                return false;
                            }}
                            accept=".jpg, .jpeg, .png"
                            onChange={handleFileChange}
                            fileList={file?.fileList}
                        >
                            {logo_remote_file_location && !imageUrl && (
                                <div
                                    style={{
                                        margin: "auto",
                                        width: 160,
                                        height: "auto",
                                        overflow: "hidden",
                                        textAlign: "center",
                                        maxHeight: 120,
                                    }}
                                >
                                    <img
                                        style={{ margin: "auto", width: "auto", maxWidth: 150, maxHeight: 100 }}
                                        src={logo_remote_file_location}
                                        alt="S3 Image"
                                    />
                                </div>
                            )}

                            {imageUrl && (
                                <div
                                    style={{
                                        margin: "auto",
                                        width: 160,
                                        height: "auto",
                                        overflow: "hidden",
                                        textAlign: "center",
                                        maxHeight: 120,
                                    }}
                                >
                                    <img
                                        style={{ margin: "auto", width: "auto", maxWidth: 150, maxHeight: 100 }}
                                        src={imageUrl}
                                        alt="Uploaded Image"
                                    />
                                </div>
                            )}
                            {file ? (
                                <div className="mt-2 file-name-elipses">
                                    <Text4 strong>Selected File:</Text4>
                                    <Text4 className="ml-2 d-block text-break">
                                        {(file || {})?.fileList[(file || {})?.fileList?.length - 1]?.name}
                                    </Text4>
                                </div>
                            ) : (
                                <div className="mt-2">
                                    <Text4 className="d-block">Click or drag file to this area to upload</Text4>
                                </div>
                            )}
                        </Upload.Dragger>
                    )}
                </Form.Item>
                <Form.Item style={{ height: "30px" }} className="my-0 mt-1">
                    {getFieldDecorator("update_for_all_cva", {
                        valuePropName: "checked",
                        initialValue: false,
                    })(<Checkbox autoComplete="off">Regenerate UPI QRs of existing Virtual Accounts.</Checkbox>)}
                </Form.Item>
                {!!current_user?.is_reseller && (
                    <Form.Item style={{ height: "30px" }} className="my-0">
                        {getFieldDecorator("update_for_all_submerchants", {
                            valuePropName: "checked",
                            initialValue: false,
                        })(<Checkbox autoComplete="off">Regenerate for Merchants.</Checkbox>)}
                    </Form.Item>
                )}

                <div className="d-flex justify-content-end mt-3">
                    <Button
                        disabled={!file && !update_for_all_cva && !update_for_all_submerchants}
                        type="primary"
                        htmlType="submit"
                        loading={isSaving}
                    >
                        Submit
                    </Button>
                </div>
            </Form>
        </EaseModal>
    );
};

QRLogoConfigModal = Form.create()(QRLogoConfigModal);

const mapStateToProps = (state) => ({
    current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
    updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QRLogoConfigModal);
